module.exports = __webpack_public_path__ + "static/media/corderocostilla.4e25191d.jpg";